<template>
  <div class="main-wrap">
    <top-image-area/>
    <top-navbar-area/>
    <transition name="fade-left-right" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
  import topImageArea from '@/components/topImageArea'
  import topNavbarArea from '@/components/topNavbarArea'
  export default {
    name: "index",
    components: {topImageArea, topNavbarArea}
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/mould/index.vue